export const VERIFIED = 'VERIFIED';
export const FAILED = 'FAILED';
export const IN_PROGRESS = 'IN_PROGRESS';
